import * as React from 'react';
import {Helmet} from "react-helmet";
import {graphql, useStaticQuery} from "gatsby";


const Wrapper = ({element}) => {

    const data = useStaticQuery(graphql`
        {
            home {
                data {
                    head
                }
            }
        }
    `)

    const text = data?.home?.data?.head;

    return (
        <>
        <Helmet>
            <script>{text}</script>
        </Helmet>
            {element}
        </>
    );
};

export default Wrapper;
